import React from "react";
import { Link } from "react-router-dom";
import {
  getBlogCardImage,
  getBlogCardImageAlt,
} from "../utils/blogRecommendations";

function BlogCards({ posts, className = "" }) {
  return (
    <div className={`blog-card-grid ${className}`}>
      {posts.map((post) => (
        <article className="blog-card" key={post.slug}>
          <img
            className="blog-card-image"
            src={getBlogCardImage(post)}
            alt={getBlogCardImageAlt(post)}
            loading="lazy"
          />
          {post.date && <span className="blog-card-date">{post.date}</span>}
          <h2>{post.title}</h2>
          <p>{post.excerpt}</p>
          <Link to={`/blog/${post.slug}`}>Leer articulo</Link>
        </article>
      ))}
    </div>
  );
}

export default BlogCards;
